import { useState } from "react"
import { ThemeProvider } from "styled-components"
import { darkTheme, lightTheme } from "./theme/Theme"
import GlobalStyle from "./styles/GlobalStyle"
import { Switch, Route } from 'react-router-dom'

//Icon
import LightIcon from './assets/switchtheme-icon/light.png'
import DarkIcon from './assets/switchtheme-icon/dark.png'

// Pages
import { MainPage } from "./pages/MainPage"
import { AboutPage } from "./pages/AboutPage"
import { BlogPage } from "./pages/BlogPage"
import { WorkPage } from "./pages/WorkPage"
import { MySkillPage } from "./pages/MySkillPage"
import { SwitchThemeButton } from "./components/SwitchThemeButton"
import Audio from './components/Audio'

function App() {

  const [isDarkTheme, setIsDarkTheme] = useState(false);

  const myTheme = isDarkTheme ? darkTheme : lightTheme;
  const [isPlay,setIsPlay] = useState(false);
  
  return(
    <>
      <GlobalStyle/>
      <ThemeProvider theme={myTheme}>
          <Audio onClick={() => setIsPlay(!isPlay)} isPlay={isPlay}/>
          <Switch>
            <Route exact path="/">
                <SwitchThemeButton 
                  onClick={() => {
                    setIsDarkTheme(!isDarkTheme)
                    setIsPlay(false)
                  }}
                  icon={isDarkTheme ? LightIcon : DarkIcon} 
                  text={isDarkTheme ? "Light" : "Dark"} 
                />
                <MainPage theme={myTheme}/>  
            </Route>
            <Route exact path="/about" component={AboutPage} />
            <Route exact path="/blog" component={BlogPage} />
            <Route exact path="/work" component={WorkPage} />
            <Route exact path="/myskill" component={MySkillPage}/>
          </Switch>
      </ThemeProvider>
    </>
  )
  }

export default App